import { forwardRef, type ReactNode, type SelectHTMLAttributes } from 'react'

import { Field } from '@/components/ui/Field'
import { ChevronDownIcon } from '@/components/ui/icons'
import { cn } from '@/lib/utils/cn'

import styles from './Select.module.css'

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  label: string
  error?: string
  hint?: string
  optional?: boolean
  hideLabel?: boolean
  size?: 'md' | 'lg'
  children: ReactNode
  className?: string
  selectClassName?: string
}

/** A native select in the same shell as the text inputs, so forms stay uniform. */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  {
    label,
    error,
    hint,
    optional,
    hideLabel,
    size = 'md',
    id,
    className,
    selectClassName,
    children,
    ...rest
  },
  ref,
) {
  return (
    <Field
      label={label}
      error={error}
      hint={hint}
      optional={optional}
      hideLabel={hideLabel}
      id={id}
      className={className}
    >
      {(control) => (
        <div className={cn(styles.control, styles[size])}>
          <select
            {...rest}
            {...control}
            ref={ref}
            className={cn(styles.select, error && styles.invalid, selectClassName)}
          >
            {children}
          </select>
          <ChevronDownIcon className={styles.chevron} />
        </div>
      )}
    </Field>
  )
})
